import AppDispatcher from './../dispatcher/AppDispatcher';
import AppConstants from './../constants/AppConstants';
import React from 'react';


/**
 * Resizer component
 * @class
 */
const Resizer = React.createClass({
  displayName: 'Resizer',


  propTypes: {
    useOrientation: React.PropTypes.bool,
  },


  /**
   * Called after component mounts to DOM
   * @returns {undefined} undefined
   */
  componentDidMount() {
    const event = this.props.useOrientation ? 'orientationchange' : 'resize';

    window.addEventListener(event, this._handleResize);
    this._handleResize();
  },


  /**
   * Called before component is removed from DOM
   * @returns {undefined} undefined
   */
  componentWillUnmount() {
    const event = this.props.useOrientation ? 'orientationchange' : 'resize';

    window.removeEventListener(event, this._handleResize);
  },


  /**
   * Renders component
   * @returns {null} null
   */
  render() {
    return null;
  },


  /**
   * Called when the browser is resized
   * @returns {undefined} undefined
   */
  _handleResize() {
    AppDispatcher.handleViewAction({
      actionType: AppConstants.WINDOW_RESIZE,
      width: window.innerWidth,
      height: window.innerHeight,
    });
  },
});

export default Resizer;
